import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { rSorgulamaSonuclari } from '../../../../api/models/.catalog';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';

export default ApiBaseReducer<
  pList,
  IInputDataStateModel<rSorgulamaSonuclari, rSorgulamaSonuclari>,
  rSorgulamaSonuclari
>(
  ActionSubTypes.API_SORGULAMASONUCLARILISTE,
  DefaultInputDataStateModel<rSorgulamaSonuclari, rSorgulamaSonuclari>()
);
